<template>
    <veui-form
        ref="form1"
        class="form-box"
        :data="formData"
        @submit="handleSubmit"
    >
        <veui-field
            v-if="fields.includes('clue_question_keyword')"
            name="clue_question_keyword"
            label="咨询内容"
            placeholder="请录入咨询内容关键词"
        >
            <veui-input
                v-model="formData.clue_question_keyword"
                placeholder="请录入咨询内容关键词"
            />
        </veui-field>
        <veui-field
            v-if="fields.includes('expertise_area_level1')"
            name="expertise_area_level1"
            label="所属领域"
        >
            <veui-select
                ref="domain"
                v-model="formData.expertise_area_level1"
                overlay-class="law-clues-select"
                class="choose-area"
                placeholder="选择领域"
                clearable
                searchable
                multiple
                :max="5"
                :options="areaOptions"
                :expanded="expandOption && expandOption.domain"
                @toggle="(val) => toggle(val, 'domain')"
            />
        </veui-field>
        <veui-field
            v-if="fields.includes('clue_city')"
            label="所属城市"
            name="clue_city"
        >
            <city-select
                placeholder="选择城市"
                :city="formData.clue_city"
                :max="5"
                @cityChange="cityChange"
            >
            </city-select>
        </veui-field>
        <veui-field
            v-if="fields.includes('is_answered')"
            label="是否被回答"
            name="is_answered"
        >
            <veui-select
                ref="isAnswer"
                v-model="formData.is_answered"
                data-stat-ignore
                clearable
                placeholder="选择是否被回答"
                :options="isAnsweredOptions"
                :expanded="expandOption && expandOption.isAnswer"
                @toggle="(val) => toggle(val, 'isAnswer')"
            />
        </veui-field>
        <veui-field
            v-if="fields.includes('public_join_ts')"
            label="咨询时间"
            name="public_join_ts"
        >
            <veui-date-picker
                v-model="formData.public_join_ts"
                range
                clearable
                :disabled-date="checkDateDisable"
            />
        </veui-field>
        <veui-field
            v-if="fields.includes('intention_status')"
            overlay-class="law-clues-select"
            label="标记状态"
            name="intention_status"
        >
            <veui-select
                ref="state"
                v-model="formData.intention_status"
                clearable
                placeholder="选择标记状态"
                overlay-class="law-clues-select"
                :options="intentionStatusOptions"
                :expanded="expandOption && expandOption.state"
                @toggle="(val) => toggle(val, 'state')"
            />
        </veui-field>
        <veui-button
            ui="primary strong" class="reset"
            @click="handleReset"
        >
            重置
        </veui-button>
        <veui-button
            ui="primary" type="submit"
            class="search"
        >
            查询
        </veui-button>
    </veui-form>
</template>
<script>
/**
 * @file search-form.vue
 * @desc 筛选表单
 * @author xingminghua@baidu.com
 */
import {
    Form,
    Field,
    Button,
    Select,
    Input,
    DatePicker
} from 'veui';
import dayjs from 'dayjs';
import {MARK_OPTIONS} from '../../../common/index';
import citySelectNew from '../../../components/citySelectNew';

const initFormData = {
    clue_question_keyword: '',
    expertise_area_level1: [],
    clue_city: [],
    is_answered: 0,
    public_join_ts: [],
    intention_status: ''
};

export default {
    name: 'search-form',
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-select': Select,
        'veui-button': Button,
        'veui-input': Input,
        'veui-date-picker': DatePicker,
        'city-select': citySelectNew
    },
    props: {
        curTab: {
            type: String,
            default: ''
        },
        cityName: {
            type: String,
            default: ''
        },
        areaOptions: {
            type: Array,
            default: () => []
        },
        lawyerDomains: {
            type: String,
            default: ''
        }
    },
    watch: {
        // 切换tab，切换筛选项，触发提交刷新列表
        curTab: {
            immediate: true,
            handler(newVal) {
                let fields = [
                    'clue_question_keyword',
                    'expertise_area_level1',
                    'is_answered',
                    'public_join_ts'
                ];
                switch (newVal) {
                    case 'localQues':
                        fields = [
                            'clue_question_keyword',
                            'expertise_area_level1',
                            'is_answered',
                            'public_join_ts'
                        ];
                        this.formData = {
                            ...this.formData,
                            expertise_area_level1: this.lawyerDomains && this.lawyerDomains.split('$') || []

                        };
                        this.$nextTick(() => {
                            this.domainObserver = this.handleIntersection(this.$refs.domain.$el, 'domain');
                            this.isAnswerObserver = this.handleIntersection(this.$refs.isAnswer.$el, 'isAnswer');
                        });
                        break;
                    case 'nationalQues':
                        fields = [
                            'clue_question_keyword',
                            'expertise_area_level1',
                            'clue_city',
                            'is_answered',
                            'public_join_ts'
                        ];
                        this.$nextTick(() => {
                            this.domainObserver = this.handleIntersection(this.$refs.domain.$el, 'domain');
                            this.isAnswerObserver = this.handleIntersection(this.$refs.isAnswer.$el, 'isAnswer');
                        });
                        break;
                    case 'isMax':
                        fields = [
                            'clue_question_keyword',
                            'expertise_area_level1',
                            'clue_city',
                            'public_join_ts'
                        ];
                        this.$nextTick(() => {
                            this.domainObserver = this.handleIntersection(this.$refs.domain.$el, 'domain');
                        });
                        break;
                    case 'myAnswer':
                        fields = ['intention_status'];
                        this.$nextTick(() => {
                            this.stateObserver = this.handleIntersection(this.$refs.state.$el, 'state');
                        });
                        break;
                }
                this.fields = fields;
                this.$nextTick(() => {
                    this.handleSubmit(this.formData);
                });
            }
        }
    },
    data() {
        return {
            fields: [
                'clue_question_keyword',
                'expertise_area_level1',
                'is_answered',
                'public_join_ts'
            ],
            formData: {...initFormData},
            isAnsweredOptions: [
                {label: '不限', value: 0},
                {label: '是', value: 1},
                {label: '否', value: 2}
            ],
            intentionStatusOptions: MARK_OPTIONS,
            // 下拉框是否展开， 所属领域、是否回答、标记状态
            expandOption: {'domain': false, 'isAnswer': false, 'state': false}
        };
    },
    mounted() {
        this.$nextTick(() => {
            // 初始tab为本地咨询， 监听选择领域与是否回答
            this.domainObserver = this.handleIntersection(this.$refs.domain.$el, 'domain');
            this.isAnswerObserver = this.handleIntersection(this.$refs.isAnswer.$el, 'isAnswer');
        });
    },
    destroyed() {
        this.domainObserver && this.domainObserver.disconnect();
        this.isAnswerObserver && this.isAnswerObserver.disconnect();
        this.stateObserver && this.stateObserver.disconnect();
    },
    methods: {
        // 城市变更
        cityChange(val) {
            this.formData.clue_city = val;
        },
        // 下拉框的选择
        toggle(val, key) {
            this.expandOption[key] = val;
        },

        // 元素是否在视口的监听, 用于下拉框的关闭操作, key用于判断是第几个下拉框
        handleIntersection(element, key) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    // 如果元素不在视口内，关闭下拉框的展开
                    if (!entry.isIntersecting) {
                        this.expandOption[key] = false;
                    }
                });
            });
            // 开始观察元素
            observer.observe(element);
            return observer;
        },
        handleSubmit(vals) {
            if (!this.curTab) {
                return;
            }
            // 只保留每个tab有的筛选条件
            let params = this.fields.reduce((pre, cur) => {
                if (vals && vals[cur]) {
                    return {
                        ...pre,
                        [cur]: vals[cur]
                    };
                }
                return pre;
            }, {});
            const {clue_city, expertise_area_level1, public_join_ts} = params;
            // 城市处理
            if (clue_city?.length) {
                params.clue_city = clue_city.join();
            }
            else {
                delete params.clue_city;
            }
            // 领域处理
            if (expertise_area_level1?.length) {
                params.expertise_area_level1 = params.expertise_area_level1.join();
            }
            else {
                delete params.expertise_area_level1;
            }
            // 时间处理
            if (public_join_ts && public_join_ts[0] && public_join_ts[1]) {
                params.public_join_ts_start = (
                    +public_join_ts[0] / 1000
                ).toFixed(0);
                params.public_join_ts_end = (+public_join_ts[1] / 1000).toFixed(
                    0
                );
            }
            delete params.public_join_ts;

            // 不同tab特殊处理
            if (this.curTab === 'localQues') {
                params.clue_city = this.cityName;
            }
            if (this.curTab !== 'myAnswer') {
                params.is_max_tab = this.curTab === 'isMax' ? 1 : 0;
            }
            this.$emit('submit', params);
        },
        handleReset() {
            this.formData = {...initFormData};
        },
        /**
         * 判断时间是否可选
         * @param {Date} date
         */
        checkDateDisable(date) {
            if (
                date
                && (date > dayjs().endOf('day')
                    || date < dayjs().subtract(15, 'day'))
            ) {
                return true;
            }
            return false;
        }
    }
};
</script>
<style lang="less" scoped>
.form-box {
    margin-top: 24px;
    padding: 0 14px;
    display: flex;
    width: 100%;
    flex-wrap: wrap;

    /deep/ .veui-input,
    .veui-select {
        width: 200px;
        min-height: 40px;
    }

    /deep/ .veui-tag {
        height: 28px;
    }

    /deep/ .veui-date-picker-range {
        width: 255px;
    }

    /deep/ .veui-field-label {
        width: 82px;
        text-align: right;
        margin-right: 0;
        margin-top: 4px;
        padding-right: 12px;
        box-sizing: border-box;
    }

    /deep/ .veui-field {
        margin-bottom: 24px;
    }

    /deep/ .veui-field:not(:last-child) {
        margin-right: 24px;
    }

    /deep/ .veui-table [role="cell"] {
        padding: 0;
    }

    /deep/ .veui-field-content {
        display: block;
        min-height: 32px;
    }

    .search {
        margin-left: 16px;
        height: 40px;
    }

    .reset,
    .search {
        width: 80px;
        height: 40px;
    }
}
</style>